














import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class UActionControl extends Vue {
  // Props

  @Prop({
    default: "u-link",
    validator: tag => ["u-link", "b-button"].includes(tag)
  })
  public readonly tag!: string;

  @Prop({ default: () => () => undefined })
  public readonly action!: Function;

  @Prop({ default: false })
  public readonly disabled!: boolean;

  @Prop({ default: undefined })
  public readonly type!: string;

  @Prop({ default: undefined })
  public readonly icon!: string;

  // Data

  public isProcessing = false;

  // Methods

  public async processAction() {
    try {
      this.isProcessing = true;
      await this.action();
    } finally {
      this.isProcessing = false;
    }
  }
}
